import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Mixin from 'components/common/Mixin'

export const SearchInputFormattedOption = ({ place }) =>
  <EllipsisOption>{ place }</EllipsisOption>

SearchInputFormattedOption.propTypes = {
  place: PropTypes.string
}

const EllipsisOption = styled.div`
  ${Mixin.ellipsis()}
`
